import React from "react";
import { EnrichedConnection, ListingWithDetails } from "../../types";
import { getItemTypeColor } from "../../utils/colors";

interface ConnectionRowInnerProps {
  enrichedConnection: EnrichedConnection;
  onClick?: (item: ListingWithDetails) => void;
}

export const ConnectionRowInner: React.FC<ConnectionRowInnerProps> = ({
  enrichedConnection,
  onClick,
}) => {
  const { listing } = enrichedConnection;
  const imgBorderColor: string = getItemTypeColor(listing.itemType);
  const imgUrl: string = listing.imageUrl || listing.coverImgUrl || "";

  return (
    <div
      className="connection-item"
      onClick={() => onClick?.(listing)}
      style={{
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {/* Image */}
      {imgUrl && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 30,
            width: 30,
            borderRadius: "50%",
            borderColor: imgBorderColor,
            borderWidth: 2,
            borderStyle: "solid",
            overflow: "hidden",
          }}
        >
          <img
            src={imgUrl}
            alt={listing.name}
            className="connection-image"
            height={24}
            width={24}
          />
        </div>
      )}
      {/* Name and connection type */}
      <span className="connection-name">{listing.name}</span>
    </div>
  );
};
